import React from "react";
import { Link } from "react-router-dom";

export default function StravaAuthFail() {
  return (
    <div>
      StravaAuthFail Page
      <br />
      <Link to="/">Homepage</Link>
    </div>
  );
}
